import React from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import { Effect } from '@pcln/home-components'
import validate from './validateRentalCars'

const noop = () => {}

const initialValues = {
  startLocation: '',
  endLocation: '',
  startDate: '',
  endDate: '',
  startTime: '12:00',
  endTime: '12:00',
  oneWay: false,
  tripType: ''
}

class RentalCarsSearchContainer extends React.Component {
  static propTypes = {
    render: PropTypes.func,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    initialValues: PropTypes.object,
    validate: PropTypes.func
  }

  static defaultProps = {
    initialValues,
    onChange: noop,
    onSubmit: noop,
    validate,
    validateOnChange: true,
    validateOnBlur: false
  }

  state = {
    calendarOpen: false,
    showStartCalendar: false,
    showEndCalendar: false
  }

  openCalendar = () => {
    this.setState({ calendarOpen: true })
  }

  closeCalendar = () => {
    this.setState({ calendarOpen: false })
  }

  toggleStartCalendar = newState => {
    this.setState({ showStartCalendar: newState })
  }

  toggleEndCalendar = newState => {
    this.setState({ showEndCalendar: newState })
  }

  handleSubmit = (values, actions) => {
    this.props.onSubmit(values, actions)
  }

  render () {
    const { render, onChange, onSubmit, ...props } = this.props

    const renderProps = {
      ...props,
      ...this.state,
      openCalendar: this.openCalendar,
      closeCalendar: this.closeCalendar,
      toggleStartCalendar: this.toggleStartCalendar,
      toggleEndCalendar: this.toggleEndCalendar
    }

    return (
      <Formik
        {...props}
        onSubmit={this.handleSubmit}
        render={formProps => (
          <div>
            <Effect onChange={onChange} />
            {render({ ...renderProps, ...formProps })}
          </div>
        )}
      />
    )
  }
}

export default RentalCarsSearchContainer
